import { types as t } from 'mobx-state-tree';
import { OddModel } from 'eTip--common';

export const RecommendedStore = t.model({
    iD: t.number,
    imgUrl: t.maybeNull(t.string),
    text: t.string,
    title: t.string,
    eventName: t.maybeNull(t.string),
    gameName: t.maybeNull(t.string),
    eventDate: t.maybeNull(t.Date),
    odds: t.maybeNull(t.array(OddModel))
});
